import { defineMessages } from 'react-intl';

const messages = defineMessages({
  todoListHeader: {
    description: 'Header for the todo list',
    defaultMessage: 'To-Do List',
    id: 'SiXoAj',
  },
  viewAll: {
    description: 'Button text to expand and show all todo items',
    defaultMessage: 'View all ({count})',
    id: 'aVgYax',
  },
  viewLess: {
    description: 'Button text to collapse and show fewer todo items',
    defaultMessage: 'View less',
    id: 'RaX356',
  },
});

export default messages;
